import Popup from "reactjs-popup";
import styled from "styled-components";

export const StyledPopup = styled(Popup)`

  &-content {
    width: 540px;
    min-height: 635px;
    height: auto;
    z-index: 10001 !important;
    padding: 0;
    border: none;
    border-radius: 10px;
    box-shadow: 1px 1px 4px 0 rgba(22, 22, 29, 0.3);
    background-color: #fff;
    & .container {
      box-sizing: border-box;
      width: 565px;
      min-height: 635px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: 16px;
      padding: 0px 32px 32px;
      border: none;
      border-radius: 10px;
      background-color: #fff;
      cursor: default;
      overflow: visible;
    }

  }

  @media (max-width: ${(props) => props.theme.breakpoints.xs}) {
    &-content {
      width: calc(100vw - 32px);
      max-width: 540px;
      min-height: auto;

      & .container {
        width: 100%;
        min-height: auto;
        padding: 0 20px 24px;
      }
    }
  }
`;

export const HeadCard = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 36.5px;
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
`;

export const Title = styled.h3`
  width: 100%;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: #3a3a3a;
`;

export const Intro = styled.p`
  width: 100%;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin: 0;
  text-align: center;
  color: #494949;
`;

export const Field = styled.div<{ $error?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  & input,
  & select {
    box-sizing: border-box;
    width: 100%;
    height: 43px;
    min-height: 43px;
    border-radius: 4px;
    border: solid 1px ${(props) => (props.$error ? "#e11417" : "#bcbcbc")};
    background-color: #fff;
    padding: 0 16px;
    font-size: 15px;
    color: #3a3a3a;
    outline: none;
    transition: border-color 0.15s ease-in-out;
  }
  & input::placeholder {
    color: #cacaca;
  }
  & select:invalid {
    color: #cacaca;
  }
  & input:focus,
  & select:focus {
    border-color: ${(props) => (props.$error ? "#e11417" : "#2f6fed")};
  }
  /* Evita que el autofill de Chrome cambie fondo/color y altere la altura */
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus,
  & input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px #fff inset;
    box-shadow: 0 0 0 1000px #fff inset;
    -webkit-text-fill-color: #3a3a3a;
    caret-color: #3a3a3a;
    transition: background-color 9999s ease-in-out 0s;
  }
`;

export const FieldError = styled.span`
  width: 100%;
  align-self: flex-start;
  text-align: left;
  color: #e11417;
  font-size: 12px;
  margin-top: 4px;
`;

export const FormGroup = styled.div`
  min-height: 396px;
  align-self: stretch;
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 25px;
  padding: 0;
`;

export const BottomCard = styled.div`
  width: 100%;
  & button {
    width: 100%;
    height: 67px;
    font-size: 18px;
    font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal
    margin-right: 0;
    padding: 20px 40px;
    border-radius: 5px;
  }
  & button:disabled {
    background-color: #e2e2e2 !important;
    border-color: #e0e0e0 !important;
    color: #fff !important;
    opacity: 1;
    cursor: not-allowed;
  }
`;

export const Footer = styled.p`
  width: 100%;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  margin: 0;
  color: #16161d;
`;

export const FooterLink = styled.a`
  color: #2f6fed;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
